var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c("div", { staticClass: "header-extra" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.name.value,
                      expression: "filters.name.value"
                    }
                  ],
                  staticClass:
                    "form-control input-md widget-header-input m-r-10",
                  attrs: {
                    type: "search",
                    placeholder: _vm.$t("PLACEHOLDER_ADDRESS_SEARCH")
                  },
                  domProps: { value: _vm.filters.name.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filters.name, "value", $event.target.value)
                    }
                  }
                })
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "m-t-10 m-b-15" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success btn-sm",
                attrs: { type: "button", disabled: _vm.disabled },
                on: { click: _vm.displayCreateForm }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "ACTION_ADD_ADDRESS",
                      expression: "'ACTION_ADD_ADDRESS'"
                    }
                  ]
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.formattedRowData,
                    "current-page": _vm.currentPage,
                    "page-size": 20,
                    filters: _vm.filters,
                    "hide-sort-icons": true
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              _vm.showCreateForm
                                ? _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "row-inline-new-form slide-down bg-row-even"
                                    },
                                    [
                                      _c(
                                        "td",
                                        { attrs: { colspan: "100" } },
                                        [
                                          _c("AddressForm", {
                                            attrs: {
                                              "show-loader":
                                                _vm.createAddressStatus
                                                  .status === "pending" ||
                                                _vm.updateAddressStatus
                                                  .status === "pending",
                                              "is-new-address": true
                                            },
                                            on: {
                                              cancel: _vm.hideCreateForm,
                                              submit: _vm.onCreate
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(displayData, function(row, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == row.id
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    attrs: {
                                                      disabled:
                                                        _vm.showCreateForm
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          row.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "name"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  class: {
                                                    clickable: !_vm.showCreateForm
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      !_vm.showCreateForm
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(row.name) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "countryCode"
                                          )
                                            ? _c("td", [
                                                _c("div", [
                                                  _c("span", {
                                                    staticClass: "flag",
                                                    class: row.countryCode.toLowerCase()
                                                  }),
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(row.countryName) +
                                                      "\n              "
                                                  )
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "addressCombined"
                                          )
                                            ? _c("td", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      row.addressCombined
                                                    ) +
                                                    "\n            "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "businessName"
                                          )
                                            ? _c("td", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(row.businessName) +
                                                    "\n            "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("AddressActions", {
                                                    attrs: {
                                                      "current-address":
                                                        _vm.addresses[index],
                                                      disabled: _vm.disabled
                                                    },
                                                    on: {
                                                      edit: _vm.displayEditForm,
                                                      "confirm-delete":
                                                        _vm.onDeleteConfirmed
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showEditForm(row.id)
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-edit",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("AddressForm", {
                                                attrs: {
                                                  "show-loader":
                                                    _vm.showFormLoader,
                                                  "current-address":
                                                    _vm.addresses[index],
                                                  "is-new-address": false
                                                },
                                                on: {
                                                  cancel: _vm.hideEditForm,
                                                  submit: _vm.onEdit
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == row.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-mobile",
                                          staticClass:
                                            "mobile-actions ng-animate-disabled slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("AddressActions", {
                                                attrs: {
                                                  "current-address": row,
                                                  disabled: _vm.disabled
                                                },
                                                on: {
                                                  "collapse-actions": function(
                                                    $event
                                                  ) {
                                                    !_vm.disabled &&
                                                      _vm.hideMobileAction()
                                                  },
                                                  edit: _vm.displayEditForm,
                                                  "confirm-delete":
                                                    _vm.onDeleteConfirmed
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }),
                              _vm._v(" "),
                              _vm.emptyTable
                                ? _c("tr", [
                                    _c("td", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "ADDRESS_TABLE_EMPTY",
                                          expression: "'ADDRESS_TABLE_EMPTY'"
                                        }
                                      ],
                                      attrs: { colspan: "100%" }
                                    })
                                  ])
                                : _vm._e()
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    1075094250
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.userVisibleColumns, function(col, index) {
                          return _c("v-th", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: _vm.columnSettings[col].displayName,
                                expression: "columnSettings[col].displayName"
                              }
                            ],
                            key: col,
                            class: _vm.columnSettings[col].class,
                            attrs: {
                              "sort-key": _vm.columnSettings[col].stSort
                            }
                          })
                        }),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "TABLE_COL_ACTIONS",
                                  expression: "'TABLE_COL_ACTIONS'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-min" }, [
                _c(
                  "div",
                  { staticClass: "text-center p-7" },
                  [
                    _c("smart-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "total-pages": _vm.totalPages,
                        "max-page-links": 20
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ADDRESS_TABLE_LOADING",
                    expression: "'ADDRESS_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }